module.exports = __webpack_public_path__ + "img/next.efd1a61c.svg";